export default "__VITE_ASSET__af62d40d__"